import axios from "axios";
import {
  CreateReviewRequest,
  CreateReviewResponse,
  ReviewResponse,
  UpdateReviewRequest,
  UpdateCorporateReviewStatusRequest,
  RegisterCorporateReviewCommentZipFile,
} from "./dto/ReviewCorporate";


// 法人レビュー一覧取得（ログインユーザーが作成したレビュー）
export const getUserReviews = async (): Promise<ReviewResponse[]> => {
  const res = await axios.get<ReviewResponse[]>(`/api/corporate/review/users`);
  return res.data;
};

// 法人レビュー一覧取得（プロジェクトの全レビュー）
export const getProjectReviews = async (projectId: string): Promise<ReviewResponse[]> => {
  const res = await axios.get<ReviewResponse[]>(`/api/corporate/review/project?id=${projectId}`);
  return res.data;
};


// 法人レビュー取得
export const getReview = async (dealId: string): Promise<ReviewResponse> => {
  const res = await axios.get<ReviewResponse>(`/api/corporate/review?id=${dealId}`, {
    headers: { "Content-Type": "application/json;charset=utf-8" },
  });
  return res.data;
};

// 法人レビュー削除
export const deleteReview = (dealId: string): Promise<void> => {
  return axios.delete(`/api/corporate/review?id=${dealId}`);
};

/**
 * 法人レビュー作成
 * @param req リクエスト
 * @returns
 */
export const createReview = async (
  req: CreateReviewRequest
): Promise<CreateReviewResponse> => {
  const res = await axios.post<CreateReviewResponse>("/api/corporate/review", req, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

/**
 * 法人レビュー更新
 * @param dealId レビューID
 * @param req リクエスト
 * @returns
 */
export const updateReview = async (
  dealId: string,
  req: UpdateReviewRequest
): Promise<ReviewResponse> => {
  const res = await axios.put<ReviewResponse>(`/api/corporate/review?id=${dealId}`, req, {
    headers: { "Content-Type": "application/json" },
  });
  return res.data;
};

/**
 * 法人レビューステータス更新
 * @param dealId レビューID
 * @param req リクエスト
 * @returns
 */
export const updateReviewStatus = async (
  dealId: string,
  req: UpdateCorporateReviewStatusRequest
): Promise<ReviewResponse> => {
  const res = await axios.put<ReviewResponse>(
    `/api/corporate/review/status?id=${dealId}`,
    req,
    {
      headers: { "Content-Type": "application/json" },
    }
  );
  return res.data;
};

// アップロードしたZipファイルの登録
export const registerZipFile = async (
  req: RegisterCorporateReviewCommentZipFile
): Promise<ReviewResponse> => {
  const formData = toFormData(req as unknown as Record<string, unknown>)
  const res = await axios.post<ReviewResponse>(
    `/api/corporate/review/zip`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return res.data;
}

// FormData型に変換
const toFormData = (req: Record<string, unknown>): FormData => {
  const data = new FormData();
  for (const [k, v] of Object.entries(req)) {
    if (v === null) {
      continue;
    }
    if (v instanceof Blob) {
      data.set(k, v);
    } else if (typeof v !== "object") {
      data.set(k, `${v}`);
    } else {
      // NOTE: FormData の値は string | Blob なので object は stringify() する
      data.set(k, JSON.stringify(v));
    }
  }
  return data;
};